import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { toneClass, type DsTone } from '@/ds/tone'
import { DsIconGlyph } from '@/ds/icon'
import { DsIcons, type DsIcon } from '@/ds/icons'
import { DsButton } from '@/ds/button'

export interface DsSuccessViewProps {
  title: string
  description?: string
  primaryLabel?: string
  onPrimary?: () => void
  secondaryLabel?: string
  onSecondary?: () => void
  tone?: DsTone
  icon?: DsIcon
  children?: ReactNode
  className?: string
}

export function DsSuccessView({ title, description, primaryLabel, onPrimary, secondaryLabel, onSecondary, tone = 'success', icon = DsIcons.check, children, className }: DsSuccessViewProps) {
  const t = toneClass[tone]
  return (
    <div className={cn('mx-auto flex w-full max-w-md flex-col items-center gap-4 py-10 text-center', className)}>
      <span className={cn('inline-flex size-20 items-center justify-center rounded-full animate-ds-scale-in', t.soft, t.onSoft)}>
        <DsIconGlyph icon={icon} size={36} />
      </span>
      <h1 className="font-display text-title1 text-foreground">{title}</h1>
      {description && <p className="text-body text-muted-foreground">{description}</p>}
      {children}
      {(primaryLabel || secondaryLabel) && (
        <div className="mt-2 flex w-full flex-col gap-2">
          {primaryLabel && <DsButton size="lg" label={primaryLabel} onClick={onPrimary} fullWidth />}
          {secondaryLabel && <DsButton variant="ghost" size="lg" label={secondaryLabel} onClick={onSecondary} fullWidth />}
        </div>
      )}
    </div>
  )
}
